import * as types from '@/store/mutation-types';
import moment from 'moment';
import debounce from 'debounce';
import 'moment-weekday-calc';

import api from './api';

export const editingAllowed = (state, update) => {
  var lockedAt = state.currentProject.lockedForEditingAt ? state.currentProject.lockedForEditingAt : '1900-01-01';

  return (
    !state.currentProject.lockedForEditingBy ||
    state.currentProject.lockedForEditingBy === state.user.username ||
    (update &&
      update.newProjectProperties &&
      update.newProjectProperties.hasOwnProperty('lockedForEditingBy') &&
      moment().diff(lockedAt, 'minute') > 60)
  );
};

export const delayedSelection = debounce(({ dispatch }, { stage, part }) => {
  if (stage) {
    dispatch('selectStage', stage);
  } else if (part) {
    dispatch('selectPart', part);
  }
}, 300);

export const setSyncStatus = function ({ commit }, status) {
  commit(types.setSyncStatus, status);
};

export const setViewSetting = function ({ commit }, update) {
  commit(types.setViewSetting, update);
};

export const fetchS3DownloadLink = async (_store, { s3Key }) => {
  return api.fetchS3DownloadLink({ s3Key });
};



// WEBPACK FOOTER //
// ./src/store/actions.js